import type { CreateColDefConfig } from './create-col-def';
import { createColDef } from './create-col-def';

export type CreateColConfig<
  TColumns extends string,
  TDefs extends string = string,
> = CreateColDefConfig<TColumns> & {
  Def?: TDefs;
};

export const createCol = <TColumns extends string, TDefs extends string = string>(
  Name: TColumns,
  config: CreateColConfig<TColumns, TDefs> = {},
) => {
  const { Def, ..._config } = config;

  return {
    Name,
    Def,
    ...createColDef(_config),
  };
};
